import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'
import { queryClient } from '@/core/lib/query-client'
import { toAdminListParams } from '@/core/lib/table-query'
import { routeHasPermission } from '@/core/utils/auth-utils'
import { dashboardRoute } from '@/modules/dashboard/dashboard.routes'
import {
  questionPoolDetailQueryOptions,
  questionPoolListQueryOptions,
  questionPoolQuestionsQueryOptions,
} from '@/modules/question-pool/question-pool.hooks'
import { questionPoolSearchSchema } from '@/modules/question-pool/question-pool.schemas'

export const questionPoolRoute = createRoute({
  path: '/question-pools',
  getParentRoute: () => dashboardRoute,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
})

export const questionPoolListRoute = createRoute({
  getParentRoute: () => questionPoolRoute,
  path: '/',
  validateSearch: questionPoolSearchSchema,
  beforeLoad: async ({ preload }) => {
    return routeHasPermission(
      preload,
      'question-pools.list',
      'Soru havuzu listesine erişim izniniz yok.'
    )
  },
  loaderDeps: ({ search }) => search,
  loader: async ({ deps }) => {
    await queryClient.ensureQueryData(
      questionPoolListQueryOptions(toAdminListParams(deps))
    )
  },
  head: () => ({
    meta: [{ title: 'Soru Havuzları' }],
  }),
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/question-pool/pages/list-question-pool.page')
  ),
})

export const questionPoolDetailRoute = createRoute({
  getParentRoute: () => questionPoolRoute,
  path: '/$id',
  validateSearch: questionPoolSearchSchema,
  beforeLoad: async ({ preload }) => {
    return routeHasPermission(
      preload,
      'question-pools.detail',
      'Soru havuzu detayına erişim izniniz yok.'
    )
  },
  loaderDeps: ({ search }) => search,
  loader: async ({ params: { id }, deps }) => {
    const params = toAdminListParams(deps, 'question')
    await Promise.all([
      queryClient.ensureQueryData(questionPoolDetailQueryOptions(id)),
      queryClient.ensureQueryData(
        questionPoolQuestionsQueryOptions(id, params)
      ),
    ])
  },
  head: () => ({ meta: [{ title: 'Soru Havuzu Detayı' }] }),
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/question-pool/pages/question-pool-detail.page')
  ),
})
